const URL_QUERY_KEYS = {
  IS_TEMP_DATA: 'isTempData',
};

export default URL_QUERY_KEYS;
